import { Injectable } from '@angular/core';
import { AURRICA_APP_CONFIG } from '../config/aurrica-app-config';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  readonly deployEnvironment = AURRICA_APP_CONFIG.deployEnvironment;
  readonly freightAppUrl = AURRICA_APP_CONFIG.freightAppUrl;
  readonly fleetAppUrl = AURRICA_APP_CONFIG.fleetAppUrl;
  readonly ituranFleetSsoBase = AURRICA_APP_CONFIG.ituranFleetSsoBase;
  readonly baseApi = AURRICA_APP_CONFIG.baseApi;
  readonly assetsHost = AURRICA_APP_CONFIG.assetsHost;
  readonly clientId = AURRICA_APP_CONFIG.clientId;
  readonly poolId = AURRICA_APP_CONFIG.poolId;
  readonly identityPoolId = AURRICA_APP_CONFIG.identityPoolId;
  readonly host = AURRICA_APP_CONFIG.host;
  readonly region = AURRICA_APP_CONFIG.region;
  readonly operational_countries = AURRICA_APP_CONFIG.operational_countries;
  readonly firebaseConfig = AURRICA_APP_CONFIG.firebaseConfig;
  readonly firebaseVapiKey = AURRICA_APP_CONFIG.firebaseVapiKey;
  readonly features = AURRICA_APP_CONFIG.features;
}
